import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"
import { ensureArray } from "lib/ensure-array"

export const rescanMapping = api((id, types) =>
    mutate(
        gql`
            mutation RescanMappingTypes($id: String!, $types: [String!]!) {
                rescanTypes(id: $id, types: $types)
            }
        `,
        { id, types: ensureArray(types) },
        { returns: "rescanTypes" }
    )
)
